import {
  ComponentFactoryResolver,
  Injectable, ViewContainerRef
} from '@angular/core';

import { KeyboardComponent } from './keyboard.component';

@Injectable({
  providedIn: 'root'
})
export class KeyboardService {
  private rootViewContainer!: ViewContainerRef;
  private instance: KeyboardComponent | undefined;

  constructor(private factoryResolver: ComponentFactoryResolver) { }

  public setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    if (!this.rootViewContainer) {
      this.rootViewContainer = viewContainerRef
    }
  }

  public addKeyboardComponent() {
    if (!this.instance) {
      const factory = this.factoryResolver.resolveComponentFactory(KeyboardComponent)
      const component = factory.create(this.rootViewContainer.parentInjector)
      this.instance = component.instance;
      this.rootViewContainer.insert(component.hostView)
    }
  }

  public getInstance() {
    return this.instance
  }

  public init(viewContainerRef: ViewContainerRef) {
    this.setRootViewContainerRef(viewContainerRef);
    this.addKeyboardComponent()
  }

}
